// Domain
const DOMAIN =
  'lending.services.public.onboarding.lzOnboarding.proofOfIncome.landing.modal.footer.';

const CONTINUE_BUTTON = `${DOMAIN}button`;

export { CONTINUE_BUTTON };
